import { css } from "lit";

export const styles = css`
  mark {
    padding: var(--size-px) var(--size-0-5);
    border-radius: var(--radius-sm);
    font-weight: var(--font-weight-semibold);
    -webkit-box-decoration-break: clone;
    box-decoration-break: clone;
    line-height: var(--line-height-normal);
    transition:
      color var(--spotlight-transition-duration),
      background-color var(--spotlight-transition-duration);
  }

  .text {
    background-color: transparent;
    padding: 0px;
    border-radius: 0px;
  }

  .red {
    color: var(--color-red-50);
  }

  .orange {
    color: var(--color-orange-50);
  }

  .green {
    color: var(--color-green-50);
  }

  .turquoise {
    color: var(--color-turquoise-50);
  }

  .cyan {
    color: var(--color-cyan-50);
  }

  .blue {
    color: var(--color-blue-50);
  }

  .violet {
    color: var(--color-violet-50);
  }

  .purple {
    color: var(--color-purple-50);
  }

  .tan {
    color: var(--color-tan-50);
  }

  .black {
    color: var(--color-neutral-90);
  }

  .red.highlight-light {
    color: var(--color-red-60);
    background-color: var(--color-red-10);
  }

  .orange.highlight-light {
    color: var(--color-orange-60);
    background-color: var(--color-orange-10);
  }

  .green.highlight-light {
    color: var(--color-green-60);
    background-color: var(--color-green-10);
  }

  .turquoise.highlight-light {
    color: var(--color-turquoise-60);
    background-color: var(--color-turquoise-10);
  }

  .cyan.highlight-light {
    color: var(--color-cyan-60);
    background-color: var(--color-cyan-10);
  }

  .blue.highlight-light {
    color: var(--color-blue-60);
    background-color: var(--color-blue-10);
  }

  .violet.highlight-light {
    color: var(--color-violet-60);
    background-color: var(--color-violet-10);
  }

  .purple.highlight-light {
    color: var(--color-purple-60);
    background-color: var(--color-purple-10);
  }

  .tan.highlight-light {
    color: var(--color-tan-60);
    background-color: var(--color-tan-10);
  }

  .black.highlight-light {
    color: var(--color-neutral-60);
    background-color: var(--color-neutral-10);
  }

  .red.highlight {
    color: var(--color-white);
    background-color: var(--color-red-50);
  }

  .orange.highlight {
    color: var(--color-white);
    background-color: var(--color-orange-50);
  }

  .green.highlight {
    color: var(--color-white);
    background-color: var(--color-green-50);
  }

  .turquoise.highlight {
    color: var(--color-white);
    background-color: var(--color-turquoise-50);
  }

  .cyan.highlight {
    color: var(--color-white);
    background-color: var(--color-cyan-50);
  }

  .blue.highlight {
    color: var(--color-white);
    background-color: var(--color-blue-50);
  }

  .violet.highlight {
    color: var(--color-white);
    background-color: var(--color-violet-50);
  }

  .purple.highlight {
    color: var(--color-white);
    background-color: var(--color-purple-50);
  }

  .tan.highlight {
    color: var(--color-white);
    background-color: var(--color-tan-50);
  }

  .black.highlight {
    color: var(--color-white);
    background-color: var(--color-neutral-50);
  }

  .red.highlight-dark {
    color: var(--color-white);
    background-color: var(--color-red-70);
  }

  .orange.highlight-dark {
    color: var(--color-white);
    background-color: var(--color-orange-70);
  }

  .green.highlight-dark {
    color: var(--color-white);
    background-color: var(--color-green-70);
  }

  .turquoise.highlight-dark {
    color: var(--color-white);
    background-color: var(--color-turquoise-70);
  }

  .cyan.highlight-dark {
    color: var(--color-white);
    background-color: var(--color-cyan-70);
  }

  .blue.highlight-dark {
    color: var(--color-white);
    background-color: var(--color-blue-70);
  }

  .violet.highlight-dark {
    color: var(--color-white);
    background-color: var(--color-violet-70);
  }

  .purple.highlight-dark {
    color: var(--color-white);
    background-color: var(--color-purple-70);
  }

  .tan.highlight-dark {
    color: var(--color-white);
    background-color: var(--color-tan-70);
  }

  .black.highlight-dark {
    color: var(--color-white);
    background-color: var(--color-neutral-70);
  }
`;
